import fetchClient, { ApiResponse } from '@/api/api-client'

import { AffUser, AffUserData } from './types/AffUser'

export async function getRef(refNum: string): Promise<AffUser> {
  try {
    const res = await fetchClient.get(`affiliate/${refNum}`)
    return res.data.data.response
  } catch (err) {
    throw err
  }
}

export async function sendEmailAffReq(data: string) {
  const payload = { data }
  try {
    const res = await fetchClient.post(`/sendEmail`, payload)
    return res.data
  } catch (err) {
    throw err
  }
}

export async function getAffiliateUserData() {
  try {
    const res = await fetchClient.get<ApiResponse<AffUserData>>(`/affiliate`)
    return res.data.data
  } catch (err) {
    throw err
  }
}
